// Function to initialize the review translation functionality
function initReviewTranslate() {
  // Add this script after the review content
  $(document).ready(function() {
    const reviews = $('.jdgm-rev');
    
    // Add spinner styles
    const style = $('<style>', {
      text: `
        .translate-container {
          margin-top: 10px;
        }
        .translate-link {
          color: #003652;
          text-decoration: underline;
          cursor: pointer;
          font-size: 11px;
          background: none;
          border: none;
          padding: 0;
        }
        .translate-link:hover {
          color: #0056b3;
        }
        .translation-spinner {
          margin: 10px 0;
          text-align: left;
          height: 20px;
          visibility: hidden;
          opacity: 0;
          transition: opacity 0.2s;
        }
        .translation-spinner.is-active {
          visibility: visible;
          opacity: 1;
        }
        .translation-spinner::after {
          content: '';
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid #003652;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spin 0.6s linear infinite;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `
    });
    $('head').append(style);

    reviews.each(function() {
      const review = $(this);
      const content = review.find('.jdgm-rev__content');
      const countryCode = review.find('.jdgm-rev__location').data('countryCode');
      
      let currentLocale = window.currentLocale || 'nl';
      const translateText = `Translate to ${currentLocale.toUpperCase()}`;
      
      if (countryCode !== currentLocale.toUpperCase()) {
        const translateContainer = $('<div>', {
          class: 'translate-container'
        });
        
        const translateButton = $('<button>', {
          text: translateText,
          class: 'translate-link'
        });
        
        const spinner = $('<div>', {
          class: 'translation-spinner',
          'aria-hidden': 'true'
        });
        
        translateContainer.append(translateButton, spinner);
        content.append(translateContainer);
        
        translateButton.on('click', function() {
          spinner.addClass('is-active');
          translateButton.hide();
          translateReview(content, () => {
            translateContainer.remove();
          });
        });
      }
    });
  });

  function translateReview(content, onComplete) {
    const title = content.find('.jdgm-rev__title');
    const body = content.find('.jdgm-rev__body');
    let completedTranslations = 0;
    const totalTranslations = (title.text().trim() !== '' ? 1 : 0) + (body.text().trim() !== '' ? 1 : 0);
    
    function checkCompletion() {
      completedTranslations++;
      if (completedTranslations === totalTranslations) {
        onComplete();
      }
    }

    // Helper function to decode HTML entities and clean text
    function cleanText(text) {
      // Create a temporary div to decode HTML entities and strip tags
      const temp = $('<div>').html(text);
      // Get text content only, removing HTML tags
      return temp.text();
    }

    // Check if there is anything to translate for the title
    if (title.text().trim() !== '') {
      const cleanedTitle = cleanText(title.html());
      translateText(cleanedTitle, currentLocale, function(translatedText) {
        title.text(translatedText);
        checkCompletion();
      });
    }

    // Check if there is anything to translate for the body
    if (body.text().trim() !== '') {
      const cleanedBody = cleanText(body.html());
      translateText(cleanedBody, currentLocale, function(translatedText) {
        body.text(translatedText);
        checkCompletion();
      });
    }
  }

  function translateText(text, targetLanguage, callback) {
    const csrfToken = getCookie('csrftoken'); // Function to get the CSRF token from cookies

    $.ajax({
        url: 'https://gssgwgo.85.10.130.70.sslip.io/translate/',
        method: 'GET',
        xhrFields: {
        withCredentials: true
        },
        headers: {
          'X-CSRFToken': csrfToken // Add CSRF token to the request headers
        },
        data: {
        text: text,
        target_language: targetLanguage
        },
        success: function(response) {
        console.log('AJAX response:', response);
        if (response.success) {
            callback(response.data.translated_text);
        } else {
            console.error('Translation failed:', response.message);
            // Handle the error in your UI
        }
        },
        error: function(xhr, status, error) {
        console.error('AJAX error:', status, error);
        let errorMessage = 'An unknown error occurred';
        if (xhr.responseJSON) {
            if (xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
            } else if (xhr.responseJSON.data && xhr.responseJSON.data.translated_text) {
            // If the translation is successful but received in the error callback
            console.log('Translation received in error callback:', xhr.responseJSON.data.translated_text);
            callback(xhr.responseJSON.data.translated_text);
            return;
            }
        }
        console.error('Error message:', errorMessage);
        // Handle the error in your UI
        }
    });
    }

  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
}

// Check for jQuery and initialize when it's available
function tryInitialize() {
  if (window.jQuery) {
    initReviewTranslate();
  } else {
    setTimeout(tryInitialize, 50);
  }
}

// Start the initialization process
tryInitialize();